<template>
	<div>
		<Top :showtop="2"></Top>
		<div class="wd-container">
			<div class="payinfo wd-flex wd-row-left">
				<div class="wd-img-80"><el-image src="../img/success.png"></el-image></div>
				<div class="wd-m-l-20">
					<div class="wd-font-18 wd-success">订单提交成功，请您尽快付款！</div>
					<div class="wd-m-t-20 wd-theme-666">
						订单号： {{ wddata.listseqno }} | 付款金额（元）：
						<span class="wd-theme wd-font-18 wd-font-bold">{{ wddata.allamount | amountFormatter }}元</span>
					</div>
					<div class="wd-m-t-20 wd-theme-999">
						请您在
						<span class="wd-theme wd-font-bold">{{ wddata.limitdate }}</span>
						前完成支付，否则订单将自动取消
					</div>
				</div>
			</div>
			<div>
				<span class="moredetail wd-cursor">
					<i class="wd-icon">&#xe6ea;</i>
					<router-link :to="{ name: 'Orderdetail', query: { posid: posid, orderno:listseqno } }" tag="span">订单详情</router-link>
				</span>
			</div>
			<div v-if="paytype == ''">
				<div class="paytype">
					<div class="title">选择支付方式</div>
					<div class="detail">
						<div class="list" v-for="(item, index) in paytypelist" :key="index" :class="item.select ? 'wd-flex wd-row-between select' : ''">
							<div @click="selectpaytype(index)" class="wd-flex wd-row-left">
								<i class="wd-icon wd-font-30 wd-theme" v-if="item.select">&#xe61e;</i>
								<i class="wd-icon wd-font-30 wd-theme" v-else>&#xe60a;</i>
								<el-image class="payimg" fit="contain" :src="item.logo" v-if="item.logo != ''"></el-image>
								<span class="wd-font-20 wd-m-l-20">{{ item.name }}</span>
								<el-image class="tjimg" fit="contain" src="../img/weixin/tj1.png" v-if="item.tj"></el-image>
							</div>
							<div v-if="item.select">
								支付
								<span class="wd-theme wd-font-20 wd-font-bold">{{ wddata.allamount | amountFormatter }}</span>
								元
							</div>
						</div>
						<!-- <div class="list ">
							<div>
								<i class="wd-icon wd-font-30 wd-theme-999">&#xe60a;</i>
								<span class="wd-font-20 wd-m-l-20">微信</span>
							</div>
						</div> -->
					</div>
				</div>
				<div class="wd-text-center"><el-button :loading="opting" :disabled="!canpay" type="primary" class="wd-p-l-50 wd-p-r-50 wd-m-t-20 wd-font-18" @click="gotopay">立即支付</el-button></div>
			</div>
			<div class="wd-m-t-20 " v-else-if="paytype == '90'">
				<div class="weixinpay">
					<!-- <div class="wd-flex wd-row-between wd-font-16">
					<div>
						订单提交成功，请尽快付款！订单号：{{wddata.listseqno}}
					</div>
					<div>
						应付金额<span class="wd-theme wd-font-bold">{{wddata.allamount|amountFormatter}}</span>元
					</div>
				</div> -->
					<div class="wd-flex wd-row-left wd-col-top wd-m-t-20">
						<div class="wd-font-18 wd-theme-666">微信支付</div>
						<div class="wd-m-l-40">
							<div class="wd-m-b-20 wd-theme-666">距离二维码过期还剩12秒，过期后请刷新页面重新获取二维码。</div>
							<div class="qrcode">
								<div class="img"><el-image class="img" :src="qrcodeurl"></el-image></div>
								<div class="wd-flex wd-row-around hinttext wd-m-t-20">
									<div><i class="wd-icon wd-font-30">&#xe623;</i></div>
									<div class="wd-font-16">
										<div>请使用微信扫描</div>
										<div>二维码以完成支付</div>
									</div>
								</div>
							</div>
						</div>
						<div class="hintimg"><el-image src="../img/weixinpayguide.png"></el-image></div>
					</div>
					<div class="wd-blue wd-m-t-20 wd-cursor wd-font-16" @click="paytype = ''">
						<i class="wd-icon ">&#xe7dd;</i>
						<span class="wd-m-l-10">选择其他支付方式</span>
					</div>
				</div>
			</div>
			<div class=" wd-m-t-20" v-else-if="paytype == '91'">
				<div class="weixinpay">
					<!-- <div class="wd-flex wd-row-between wd-font-16">
					<div>
						订单提交成功，请尽快付款！订单号：{{wddata.listseqno}}
					</div>
					<div>
						应付金额<span class="wd-theme wd-font-bold">{{wddata.allamount|amountFormatter}}</span>元
					</div>
				</div> -->
					<div class="wd-flex wd-row-left wd-col-top wd-m-t-20">
						<div class="wd-font-18 wd-theme-666">支付宝支付</div>
						<div class="wd-m-l-40">
							<div class="wd-m-b-20 wd-theme-666">距离付款过期还剩{{ hour }}:{{ minute }}:{{ second }}，过期后将无法付款。</div>
							<div class="zfb" id="zfb"><div v-html="zfbhtml"></div></div>
						</div>
					</div>
					<div class="wd-blue wd-m-t-20 wd-cursor wd-font-16" @click="backselect">
						<i class="wd-icon ">&#xe7dd;</i>
						<span class="wd-m-l-10">选择其他支付方式</span>
					</div>
				</div>
			</div>
		</div>

		<Footer></Footer>
	</div>
</template>

<script>
import Top from '@/components/layout/Top4.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
	name: 'Pay',
	components: {
		Top,
		Footer
	},
	data() {
		return {
			paytype: '',
			posid: '',
			wddata: '',
			paytypelist: [
				{ id: 90, name: '微信支付', amount: 0, select: true, tj: true, logo: '../img/weixin/wxlogo.png' },
				{ id: 91, name: '支付宝', amount: 0, select: false, tj: false, logo: '' }
			],
			payamount: 0.0,
			hour: 2,
			minute: 0,
			second: 0,
			loaderror: true,
			payinfo2: '',
			allseconds: 0,
			paypass: '',
			showpay2: false,
			qrcodeurl: '',
			paystate: '',
			interval: null,
			zfbhtml: '',
			listseqno: '',
			canpay:true,
			opting:false
		};
	},
	created() {
		let params = this.$route.query;
		this.posid = params.posid || '';
		this.listseqno = params.orderno || '';
		if (this.posid !== '' && this.listseqno !== '') {
			this.getpos();
		}else{
			this.$router.push({name:"Error"});
		}
	},
	destroyed(){
		console.log("destroyed");
		this.clearinterval();
	},
	methods: {
		backselect() {
			this.paytype = '';
			this.clearinterval();
		},
		gotopay() {
			this.opting=true;
			for (var i = 0; i < this.paytypelist.length; i++) {
				if (this.paytypelist[i].select) {
					if (this.paytypelist[i].id == '90') {
						this.paytype = '90';
					} else if (this.paytypelist[i].id == '91') {
						this.paytype = '91';
					}
					break;
				}
			}
			if (this.paytype === '90') {
				if (this.qrcodeurl == '') {
					this.pay();
				}
			} else if (this.paytype === '91') {
				var indata = {
					posid: this.posid,
					total: this.payamount
				};
				this.$wd_request('alipayweb_payrequest', indata)
					.then(data => {
						console.log(data);
						var formstr = data.value.body;
						let routeData = this.$router.resolve({
							name: 'Alipay',
							query: { formstr: formstr }
						});
						window.open(routeData.href, '_blank');
						// this.$router.push({name:"Alipay",params:{formstr:formstr}})
						// this.zfbhtml=formstr;
						// this.$nextTick(()=>{
						// 	document.forms[0].submit();
						// })
					})
					.catch(data => {
						console.log(data);
						this.opting=false;
					});
			}
		},
		selectpaytype(index) {
			for (var i = 0; i < this.paytypelist.length; i++) {
				if (i === index) {
					this.paytypelist[i].select = true;
				} else {
					this.paytypelist[i].select = false;
				}
			}
		},
		// loaddata() {
		// 	let indata={
		// 		posid:this.posid
		// 	}
		// 	this.$wd_request("poslist",indata,true)
		// 	.then(data=>{
		// 		this.wddata=data.value;
		// 	})
		// 	.catch(()=>{
		// 		console.log("nodata");
		// 	})
		// },
		getpos() {
			let indata = {
				posids: this.posid
			};
			this.$wd_request('pospay', indata, true)
				.then(data => {
					this.loaderror = false;
					this.wddata = data.value;
					this.payamount = this.wddata.allamount;
					if (this.payamount==0){
						this.$router.push({
							name: 'Paysuccess',
							query: { posid: this.posid, orderno: this.wddata.listseqno}
						});
					}else{
						this.diffTime(this.wddata.nowdate, this.wddata.limitdate);
						if (this.wddata.wxqrcode != '') {
							this.loaderror = true;
							this.paytype = '90';
							this.qrcodeurl = 'https://weida.duoxiaobao.net/qrcode.php?data=' + this.wddata.wxqrcode;
							this.paystate = '微信支付：待支付';
							this.checkpayresult(this.wddata.listseqno, 'wxpay');
						}
					}
				})
				.catch(data => {
					this.loaderror = true;
					this.canpay=false;
					if (data.value==="0"){
						this.$router.push({
							name: 'Paysuccess',
							query: { posid: this.posid, orderno: this.wddata.listseqno }
						});
					}else{
						this.$wd_msg(data.msg);
					}
					// this.$wd_toast(data.msg);
				});
		},
		checkpayresult(listseqno, paytype) {
			var that = this;
			if (this.posid !== '') {
				this.interval = setInterval(function() {
					var indata = { listseqno: listseqno };
					that.$wd_request(paytype + '_orderquery', indata).then(() => {
						that.paystate = '支付成功';
						that.clearinterval();
						that.$wd_toast('支付成功');
						that.qrcodeurl = '';
						that.$router.push({
							name: 'MemberIndex',
							query: { aflag: 'Orderlist' }
						});
						// uni.switchTab({
						// 	url:"../my/my"
						// })
					});
				}, 5000);
			}
		},
		async pay() {
			if (this.loaderror == true || this.allseconds <= 0) {
				this.$wd_toast('订单已失效，无法支付',"error");
				return;
			}

			var code = this.paytype;
			var that = this;
			if (code == '90' || code == '91' || code == '901') {
				let payinfo = await this.getOrderInfo(code);
				if (payinfo.rs != 0) {
					return;
				}
				let pinfo = payinfo.value;
				var wxqrcode = pinfo.wxqrcode || '';
				if (wxqrcode != '') {
					// console.log(pinfo.wxqrcode);
					that.qrcodeurl = 'https://weida.duoxiaobao.net/qrcode.php?data=' + pinfo;
					that.qrcodepopup = true;
					that.paystate = '微信支付：待支付';
					that.checkpayresult(payinfo.listseqno, 'wxpay');
					that.paytype = '901';
					return;
				}
				// console.log("code:"+code);
				if (code == '90') {
					that.qrcodeurl = 'https://weida.duoxiaobao.net/qrcode.php?data=' + pinfo;
					that.qrcodepopup = true;
					that.paystate = '微信支付：待支付';
					that.checkpayresult(payinfo.listseqno, 'wxpay');
				}
			}
		},
		getOrderInfo() {
			var appid = process.env.VUE_APP_NETCODE;
			let indata = {
				total: this.payamount,
				appid: appid,
				posid: this.posid
			};
			if (this.paytype == '90') {
				indata.tradetype = 'NATIVE';
				return new Promise(res => {
					this.$wd_request('wx_payrequest', indata).then(data => {
						res(data);
					});
				});
			} else if (this.paytype == '91') {
				return new Promise(res => {
					this.$wd_request('alipay_payrequest', indata, this, function(that, data) {
						res(data);
					});
				});
			} else if (this.paytype == '901') {
				indata.tradetype = 'NATIVE';
				return new Promise(res => {
					this.$wd_request('wx_payrequest', indata, this, function(that, data) {
						res(data);
					});
				});
			}
		},
		clearinterval() {
			if (this.interval !== null) {
				console.log('unloadclear');
				clearInterval(this.interval);
				this.interval = null;
			}
		},
		diffTime(sDate, eDate) {
			var startDate = this.$weidajs.strtodate(sDate);
			var endDate = this.$weidajs.strtodate(eDate);
			var diff = endDate.getTime() - startDate.getTime(); //时间差的毫秒数
			this.allseconds = diff;
			if (diff < 0) {
				this.hour = 0;
				this.minute = 0;
				this.second = 0;
				return;
			}
			//计算出相差天数
			// var days=Math.floor(diff/(24*3600*1000));
			//计算出小时数
			var leave1 = diff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
			var hours = Math.floor(leave1 / (3600 * 1000));
			//计算相差分钟数
			var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
			var minutes = Math.floor(leave2 / (60 * 1000));
			//计算相差秒数
			var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
			var seconds = Math.round(leave3 / 1000);
			this.hour = hours;
			this.minute = minutes;
			this.second = seconds;
		}
	}
};
</script>

<style lang="scss" scoped>
.weixinpay {
	background-color: #fff;
	padding: 12px 30px;
	box-shadow: 0 6px 32px rgba(0, 0, 0, 0.13);
	.qrcode {
		margin-bottom: 20px;
		border: 1px solid #ddd;
		width: 298px;
		height: 298px;
		.img {
			width: 298px;
			height: 298px;
		}
	}
	.hinttext {
		background-color: #ff7674;
		color: #ffffff;
		padding: 10px 20px;
	}
	.hintimg {
		height: 44px;
		padding: 8px 0 8px 125px;
		width: 379px;
		height: 421px;
		padding-left: 50px;
		margin-top: -20px;
		.img {
			width: 379px;
			height: 421px;
		}
	}
}
.payinfo {
	margin-top: 40px;
	border-top: 2px solid #7abd54;
	background-color: #f1f8ee;
	position: relative;
	padding-left: 66px;
	min-height: 116px;
	padding-bottom: 20px;
}
.moredetail {
	display: block;
	width: 108px;
	height: 32px;
	background-color: #f1f8ee;
	border: 1px solid #d7ebcb;
	border-top-color: #f1f8ee;
	margin: -1px auto 0;
	position: relative;
	line-height: 30px;
	font-size: 14px;
	color: #649a45;
	text-align: center;
}
.paytype {
	background: #fff;
	padding: 12px 30px;
	box-shadow: 0 6px 32px rgba(0, 0, 0, 0.13);
	z-index: 1;
	margin-top: 20px;
	.title {
		height: 40px;
		line-height: 40px;
		text-align: center;
		margin-bottom: 20px;
	}
	.detail {
		.list {
			height: 80px;
			line-height: 80px;
			border-bottom: 1px solid #eee;
			padding: 6px 18px 6px 18px;
			box-sizing: border-box;
			cursor: pointer;
			&.select {
				box-shadow: 0 0 6px rgba(10, 22, 57, 0.13);
				border-radius: 3px;
			}
			.payimg {
				margin-left: 20px;
				height: 30px;
				width: 30px;
			}
			.tjimg {
				height: 16px;
				width: 40px;
			}
		}
	}
}
</style>
